export default {
    accountSetting: 'Account Setting',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    name: 'Name',
    surname: 'Surname',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    role: 'Role',
    msgRequiredField: 'This field is required',
    congratulation: 'Congratulation',
    userprofileIsUpdated: 'Userprofile is updated.',
    resetPassword: 'Reset password',
    currentPassword: 'Current password',
    placeholderCurrentPassword: 'Enter your Current password',
    newPassword: 'New password',
    placeholderNewPassword: 'Enter your New password',
    confirmPassword: 'Confirm password',
    placeholderConfirmPassword: 'Enter your New password again'
}
